import { COOKIES, COOKIES_TIMES } from ".constants/cookies";
import { GE } from ".constants/gtmEvents";
import { PATH_BUY } from ".constants/links";
import { Button } from "@cloai/uikit";
import dayjs from "dayjs";
import { useTranslations } from "next-intl";
import { memo, MouseEvent } from "react";
import { useCookies } from "react-cookie";

import { useRouter } from "@/i18n";
import { useGTMContext } from "@/providers";

import { ToastCloseFunction } from "../offer-change-lang/types";

type ToastContentProps = {
  closeToast: ToastCloseFunction;
};

export const ToastContent = memo(({ closeToast }: ToastContentProps) => {
  const t = useTranslations("ToastLowBalance");
  const router = useRouter();
  const { sendGTM } = useGTMContext();
  const [, setCookie] = useCookies([COOKIES.PROMO_PACK_ENDTIME]);

  const wrapFn = (e: MouseEvent, callback: () => void) => {
    e.preventDefault();
    e.stopPropagation();
    callback();
    closeToast(true);
  };

  const onAccept = () => {
    sendGTM({ event: GE.TOAST_LOW_BALANCE_ACCEPT });
    setCookie(COOKIES.PROMO_PACK_ENDTIME, dayjs().add(1, "day").toDate(), {
      maxAge: COOKIES_TIMES.DAY_1,
    });
    router.push(PATH_BUY, { scroll: false });
  };

  const onCancel = () => {
    sendGTM({ event: GE.TOAST_LOW_BALANCE_CANCEL });
  };

  return (
    <div className="flex flex-col gap-2">
      <p>{t("toastTitle")}</p>
      <div className="mt-2 flex w-full items-center justify-end gap-2">
        <Button
          variant="ghost"
          size="md"
          wide
          onClick={(e) => wrapFn(e, onCancel)}
        >
          {t("declineBtnText")}
        </Button>

        <Button
          size="md"
          color="primary"
          wide
          onClick={(e) => wrapFn(e, onAccept)}
        >
          {t("acceptBtnText")}
        </Button>
      </div>
    </div>
  );
});

ToastContent.displayName = "ToastContent";
